import React, { useState } from "react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { BaseFormFields, useBaseForm } from "./BaseFormFields";

export function GeneralITRequestForm({ onSubmit, initialData, readOnly, submitting, onTitleChange, allowedPriorities, ticketType, onTypeChange }) {
    const baseForm = useBaseForm("medium");
    const [requestSubject, setRequestSubject] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            title: baseForm.title || requestSubject,
            description: baseForm.description,
            priority: baseForm.priority,
            dynamic_fields: {
                request_subject: requestSubject,
            },
        });
    };

    return (
        <form onSubmit={handleSubmit} data-testid="general-it-request-form">
            <BaseFormFields
                ticketType={ticketType}
                onTypeChange={onTypeChange}
                {...baseForm}
                onTitleChange={onTitleChange}
                allowedPriorities={allowedPriorities}
                titlePlaceholder="Ex: Création liste de diffusion marketing"
                descriptionPlaceholder="Décrivez votre besoin en détail..."
            >
                <div className="form-group">
                    <Label className="form-label">Objet de la demande</Label>
                    <Input
                        value={requestSubject}
                        onChange={(e) => setRequestSubject(e.target.value)}
                        placeholder="Ex: Création liste de diffusion, accès VPN, configuration imprimante..."
                        data-testid="request-subject"
                    />
                </div>
            </BaseFormFields>

            <div className="mt-6 flex justify-end">
                <Button type="submit" disabled={!baseForm.title || submitting} data-testid="submit-ticket">
                    {submitting ? "Création..." : "Soumettre le ticket"}
                </Button>
            </div>
        </form>
    );
}
